import { useMutation, useQueryClient } from '@tanstack/react-query';
import { strapiCopyQuotation } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function useCopyQuotationMutation(jwt: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (sourceDocumentId: string) => {
      if (!jwt) throw new Error('Not signed in');
      return strapiCopyQuotation(jwt, sourceDocumentId);
    },
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: queryKeys.quotationsListPrefix(jwt) });
    },
  });
}
